import { GET } from '../request'

export const buscarPorEmailAlumno = email =>
  GET('/api/agora/alumnos/alumno/list/search/email', { email })

export const buscarPorTelefonoAlumno = telefono =>
  GET('/api/agora/alumnos/alumno/list/search/telefono', { telefono })

export const buscarPorEmailLead = email =>
  GET('/api/agora/marketing/feedback/list/search/email', { email })

export const buscarPorTelefonoLead = telefono =>
  GET('/api/agora/marketing/feedback/list/search/telefono', { telefono })
